import { PropsWithChildren } from 'react'

import { GenericalRecord } from '../../types/utilities'

import { ContextMenuCore } from './Core'
import { ContextMenuProps } from './interface'
import { ContextMenuStoreProvider } from './Store'

export const ContextMenu = <T extends GenericalRecord>({
  children,
  /* ************************************************************************** */
  /*                       ContextMenuStoreProvider Props                       */
  /* ************************************************************************** */
  offset,
  onClose,
  onOpen,
  /* -------------------------------------------------------------------------- */
  /*                            ContextMenuCore Props                           */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: PropsWithChildren<ContextMenuProps<T>>) => {
  return (
    <ContextMenuStoreProvider offset={offset} onClose={onClose} onOpen={onOpen}>
      <ContextMenuCore {...restProps}>{children}</ContextMenuCore>
    </ContextMenuStoreProvider>
  )
}
